import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";

export const JsonViewer = ({ data, testId }) => {
  const json = typeof data === "string" ? data : JSON.stringify(data, null, 2);

  return (
    <div
      data-testid={testId}
      className="rounded-md border border-zinc-800 bg-[#0a0a0a] overflow-x-auto thin-scroll"
    >
      <SyntaxHighlighter
        language="json"
        style={vscDarkPlus}
        wrapLongLines={false}
        customStyle={{
          margin: 0,
          padding: "1rem",
          background: "transparent",
          fontSize: "12.5px",
          fontFamily: "'JetBrains Mono', monospace",
          lineHeight: 1.6,
        }}
        codeTagProps={{ style: { fontFamily: "'JetBrains Mono', monospace" } }}
      >
        {json}
      </SyntaxHighlighter>
    </div>
  );
};
